import { borderRadius, color, spacer } from '@figma/fpl-tokens/tokens.stylex';
import * as stylex from '@stylexjs/stylex';

export const paywallLayout = stylex.defineConsts({
  cardHeight: '389px',
  iconSize: '16px',
  priceRowHeight: '32px',
});

export const modalStyles = stylex.create({
  modal: {
    backgroundColor: color.bgSecondary,
    backgroundImage: 'linear-gradient(180deg, rgba(44, 44, 44, 0.3) 22%, rgba(44, 44, 44, 0.8) 124%)',
    backgroundSize: '1627px 1200px',
    backgroundPosition: 'center calc(50% + 78px)',
    backgroundRepeat: 'no-repeat',
    backgroundBlendMode: 'color-burn',
  },
  lightModal: {
    backgroundColor: color.bg,
    backgroundImage: 'none',
  },
  bodyPadding: {
    padding: spacer.spacer6,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacer.spacer4,
  },
  header: {
    display: 'inherit',
    flexDirection: 'inherit',
    alignItems: 'center',
    gap: spacer.spacer3,
    textAlign: 'center',
  },
  headerCopy: {
    gap: spacer.spacer1,
    display: 'inherit',
    flexDirection: 'inherit',
  },
  headerText: {
    margin: 0,
  },
  cards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 300px))',
    height: paywallLayout.cardHeight,
    justifyContent: 'center',
    gap: spacer.spacer3,
  },
  footer: {
    padding: spacer.spacer3,
    textAlign: 'center',
    boxShadow: 'none',
  },
  footerText: {
    marginTop: spacer.spacer4,
    marginBottom: 0,
    textAlign: 'center',
  },
  footerAction: {
    border: 0,
    padding: 0,
    color: color.text,
    background: 'transparent',
    cursor: 'pointer',
    font: 'inherit',
    textDecoration: 'underline',
    textUnderlinePosition: 'from-font',
  },
});

export const planCardStyles = stylex.create({
  card: {
    display: 'flex',
    minWidth: 0,
    flexDirection: 'column',
    gap: spacer.spacer3,
    padding: spacer.spacer4,
    borderRadius: borderRadius.large,
  },
  outlinedCard: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: color.border,
  },
  emphasizedCard: {
    backgroundColor: color.bgSecondary,
  },
  lightCard: {
    backgroundColor: color.bg,
  },
  lightEmphasizedCard: {
    outline: '1px solid var(--ramp-grey-500)',
    outlineOffset: -1,
  },
  planHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacer.spacer1,
  },
  planHeaderText: {
    margin: 0,
  },
  priceRow: {
    display: 'flex',
    height: paywallLayout.priceRowHeight,
    alignItems: 'center',
    gap: spacer.spacer2,
    margin: 0,
  },
  price: {
    fontSize: 28,
    lineHeight: '32px',
    whiteSpace: 'nowrap',
  },
  priceSuffix: {
    alignSelf: 'flex-end',
  },
  credits: {
    display: 'flex',
    minHeight: 32,
    alignItems: 'flex-start',
    gap: spacer.spacer1,
  },
  creditCopy: {
    display: 'flex',
    minWidth: 0,
    flex: 1,
    flexDirection: 'column',
  },
  featuresSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacer.spacer2,
    paddingTop: spacer.spacer3,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: color.border,
  },
  features: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacer.spacer2,
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  feature: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: spacer.spacer2,
  },
  featureCopy: {
    minWidth: 0,
    flex: 1,
  },
  buttonTheme: {
    '--color-text-onbrand': 'var(--ramp-grey-800)',
    '--color-icon-onbrand': 'var(--ramp-grey-800)',
    '--color-bg-disabled': 'var(--weave-pricing-disabled-background)',
    '--color-text-ondisabled': 'var(--weave-pricing-disabled-text)',
    '--color-icon-ondisabled': 'var(--weave-pricing-disabled-icon)',
    '--color-bg-brand': 'var(--ramp-lime-400)',
    '--color-bg-brand-hover': 'var(--ramp-lime-300)',
    '--color-bg-brand-pressed': 'var(--ramp-lime-200)',
  },
});

export const paywallIconStyles = stylex.create({
  icon: {
    width: paywallLayout.iconSize,
    height: paywallLayout.iconSize,
    flexShrink: 0,
    color: color.iconSecondary,
    '--fpl-icon-color': color.iconSecondary,
  },
  accentIcon: {
    color: 'var(--weave-pricing-badge-text)',
    '--fpl-icon-color': 'var(--weave-pricing-badge-text)',
  },
});
